import {
  FilterContentFieldDataTypes,
  SortDirection,
  Newest,
  Oldest,
  AlphabeticalAsc,
  AlphabeticalDesc,
  IFilter,
  SortDropdownOption
} from '@hevoio/hevo-ui-toolkit';
import { DESTINATION_TYPES } from '../../../destination/constants/destinationTypes';
import { ActivationStatusEnum } from '../../models/activation-status';
import ActivateTargetAPI from '../../../activate-target/ActivateTargetAPI';
import DestinationsAPI from '../../../destination/api/DestinationsAPI';
import { RawDestination } from '../../../destination/interfaces/destination';

export const ACTIVATION_FILTERS: IFilter[] = [
  {
    title: 'Warehouse',
    filterKey: 'warehouse_name',
    filterType: FilterContentFieldDataTypes.LIST,
    filterContentProps: {
      multiple: true,
      dataSource: () =>
        DestinationsAPI.getDestinations().then(res =>
          (res.data as RawDestination[])
            .filter(destination => DESTINATION_TYPES[destination.dest_type].isActivateDestination)
            .map(destination => ({
              label: destination.name,
              value: destination.name,
              logo: {
                logo: destination.dest_type_logo_url,
                logoDarkMode: destination.dest_type_dark_mode_logo_url
              }
            }))
        ),
      textFieldProps: {
        prefixIcon: 'search',
        placeholder: 'Search Warehouse'
      }
    }
  },
  {
    title: 'Target',
    filterKey: 'target_name',
    filterType: FilterContentFieldDataTypes.LIST,
    filterContentProps: {
      multiple: true,
      dataSource: () =>
        ActivateTargetAPI.getTargets().then(res =>
          res.data.map((target: any) => ({
            label: target.name,
            value: target.name,
            logo: {
              logo: target.type_logo_url,
              logoDarkMode: target.type_dark_mode_logo_url
            }
          }))
        ),
      textFieldProps: {
        prefixIcon: 'search',
        placeholder: 'Search Target'
      }
    }
  },
  {
    title: 'Status',
    filterKey: 'status',
    filterType: FilterContentFieldDataTypes.LIST,
    filterContentProps: {
      multiple: true,
      selectMode: true,
      options: ActivationStatusEnum.toArray().map(s => ({
        ...s,
        label: s.name
      })),
      textFieldProps: {
        prefixIcon: 'search',
        placeholder: 'Search By Status'
      }
    }
  }
];

export const ACTIVATION_SORT_DROPDOWN_OPTIONS: SortDropdownOption[] = [
  {
    label: Newest,
    key: 'id',
    direction: SortDirection.DESC
  },
  {
    label: Oldest,
    key: 'id',
    direction: SortDirection.ASC
  },
  {
    label: AlphabeticalAsc,
    key: 'name',
    direction: SortDirection.ASC
  },
  {
    label: AlphabeticalDesc,
    key: 'name',
    direction: SortDirection.DESC
  },
  {
    label: 'Most Recently Run',
    key: 'lastRunTs',
    direction: SortDirection.DESC
  },
  {
    label: 'Least Recently Run',
    key: 'lastRunTs',
    direction: SortDirection.ASC
  }
];
